import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IUser,
  IUserDepartment,
  IUserRole,
} from "../../modules/user/model/user";
import { IUserfunctionalities } from "../../modules/auth/model/auth";

interface UserProfile {
  all_functionalities: IUserfunctionalities[];
  userDepartment: IUserDepartment;
  userRole: IUserRole;
}

interface UserState {
  user: Partial<IUser> | null;
  profile: UserProfile | null;
  access_token: string | null;
  refresh_token: string | null;
  functionalities: string[];
}

const initialState: UserState = {
  user: null,
  profile: null,
  access_token: null,
  refresh_token: null,
  functionalities: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (
      state,
      action: PayloadAction<{
        user: Partial<IUser>;
        profile: UserProfile;
        access_token: string;
        refresh_token: string;
      }>
    ) => {
      state.user = action.payload.user;
      state.profile = action.payload.profile;
      state.access_token = action.payload.access_token;
      state.refresh_token = action.payload.refresh_token;
      state.functionalities = action.payload.profile.all_functionalities.map(
        (fun) => fun.functionality.functionality
      );
    },
    // updateUser: (state, action: PayloadAction<Partial<IUser>>) => {
    //   if (state.user) {
    //     state.user = { ...state.user, ...action.payload };
    //   }
    // },
    updateUserProfile: (state, action: PayloadAction<Partial<UserProfile>>) => {
      if (state.profile) {
        state.profile = { ...state.profile, ...action.payload };
        if (action.payload.all_functionalities) {
          state.functionalities = action.payload.all_functionalities.map(
            (fun) => fun.functionality.functionality
          );
        }
      }
    },
    updateTokens: (
      state,
      action: PayloadAction<{
        access_token?: string;
        refresh_token?: string;
      }>
    ) => {
      if (action.payload.access_token) {
        state.access_token = action.payload.access_token;
      }
      if (action.payload.refresh_token) {
        state.refresh_token = action.payload.refresh_token;
      }
    },
    clearUserData: (state) => {
      return initialState;
    },
  },
});

export const {
  setUserData,
  //updateUser,
  // updateUserProfile,
  // updateTokens,
  // clearUserData,
} = userSlice.actions;

export default userSlice.reducer;
